export default __webpack_public_path__ + "static/media/jpmorgan-chase.7ae19342.svg";